var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIntentionality = function SvgIntentionality(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.35 24.07a1.001 1.001 0 0 1 1.5.864v6.063a1 1 0 0 1-1.5.866l-5.25-3.03a1 1 0 0 1 0-1.733l5.25-3.03Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16 22.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Z",
    opacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.937 2.603A14 14 0 1 1 15.999 30a2 2 0 1 1 0-4 10 10 0 1 0-7.07-2.93A2 2 0 0 1 6.1 25.9a14 14 0 0 1 5.837-23.297Z",
    clipRule: "evenodd"
  })));
};
export default SvgIntentionality;